/**
 * The copyright line.
 *
 * One component, for the same reason the wordmark is one: a notice that says a different year, or
 * a different name, on two pages of the same product is worse than no notice at all. Every place
 * that shows it — the sign-in pages, the landing footer, the rail, and the two pages a tenant sees
 * without an account — renders this.
 *
 * **The year is read from the clock, not typed.** A hard-coded year is correct for twelve months
 * and then quietly wrong on every page for the rest of the product's life. Where the current year
 * is past the first one, the line spans them, which is the form a notice is expected to take once
 * a work has been published across more than one year.
 */

/** The year the product was first published. Only ever moves backwards, and only if that is wrong. */
const FIRST_YEAR = 2026;

export function Copyright({
  className = "",
  tone = "dark",
}: {
  className?: string;
  /** `dark` writes in grey, for a light background; `light` writes in white, for the green grounds. */
  tone?: "dark" | "light";
}) {
  const year = new Date().getFullYear();
  const span = year > FIRST_YEAR ? `${FIRST_YEAR}–${year}` : `${FIRST_YEAR}`;

  return (
    <p className={`text-xs ${tone === "light" ? "text-white/50" : "text-ink-400"} ${className}`}>
      © {span} RentorNG. All rights reserved.
    </p>
  );
}
